import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

// TODO: AuthGuard redirects to / on refresh – wait for auth state to load before checking
export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./pages/auth/login/login').then(m => m.Login),
    },
    {
        path: '',
        canActivate: [authGuard],
        children: [
            { path: '', loadComponent: () => import('./pages/product-catalog/product-catalog').then(m => m.ProductCatalog) },
            {
                path: 'product-catalog/:id',
                loadComponent: () => import('./pages/product-catalog/product-catalog').then(m => m.ProductCatalog),
            },
            {
                path: 'head-product/:id',
                loadComponent: () => import('./pages/product-detail/product-detail').then(m => m.HeadProductDetail),
            },
            { path: 'product-basket', loadComponent: () => import('./pages/product-basket/product-basket').then(m => m.ProductBasket) },
            { path: 'shopping-lists', loadComponent: () => import('./pages/shopping-lists/shopping-lists').then(m => m.ShoppingLists) },
            {
                path: 'shopping-lists/:id',
                loadComponent: () => import('./pages/shopping-list-detail/shopping-list-detail').then(m => m.ShoppingListDetail),
            },
        ],
    },
    {
        path: '**',
        redirectTo: '/login',
    },
];
